import * as React from "react";
import PatientCandidatsList from "./PatientCandidatsList";
import {
  PatientByDDNLookupState,
  PatientByNameLookupState,
  useSelectedPatientIds,
} from "../../main/state/globalState";
import { useAtom } from "jotai";
import { trpc } from "../../main/components/trpc.ts";
import { Transforms } from "cadendar-shared";
import styles from "./PatientLookup.module.css";
import { skipToken } from "@tanstack/react-query";
import _ from "underts";
import { checkers, formaters } from "vincent-utils";
import InputIcon from "../../main/components/InputIcon";
import { MdOutlineCancel } from "react-icons/md";

const PatientLookup = () => {
  const [lookup, setLookup] = useAtom(PatientByNameLookupState);
  const [ddnLookup, setDdnLookup] = useAtom(PatientByDDNLookupState);
  const [
    selectedPatientsIds,
    {
      selectPatientId,
      isMultiSelectionEnabled,
      setIsMultiSelectionEnabled,
      togglePatientId,
    },
  ] = useSelectedPatientIds();
  const { data: candidates } = trpc.patient.findByName.useQuery(
    { nameLookup: lookup },
    { enabled: !!lookup && lookup.length > 1 }
  );

  const onResetLookup = () => {
    setLookup("");
  };

  const onResetDdnLookup = () => {
    setDdnLookup("");
  };

  const ddnLookupFormatted = formaters.formatDDNForStoring(ddnLookup);

  const isValidDDN =
    !!ddnLookupFormatted && checkers.isValidDdn(ddnLookupFormatted);

  console.log("ddnLookupFormatted", ddnLookupFormatted);

  const { data: candidatesByDDN } = trpc.patient.findByDDN.useQuery(
    isValidDDN ? { ddnLookup: ddnLookupFormatted } : skipToken
  );

  const mergedCandidates = [...(candidates || []), ...(candidatesByDDN || [])];
  const uniqueCandidates = _.uniq(mergedCandidates, false, (c) => c.id);
  const sorter = Transforms.patients.curriedSpecialSort(lookup);
  const sortedCandidates = uniqueCandidates.sort(sorter);
  return (
    <>
      <div>
        <div className={styles.inputSpacer}>
          <label htmlFor="patient_nom_lookup" className={styles.label}>
            Nom
          </label>
          <div>
            <InputIcon
              value={lookup}
              onChange={setLookup}
              tooltip="Effacer"
              showIcon={!!lookup}
              iconTestId="patient_nom_lookup_icon"
              isValid={lookup.length > 1}
              iconShiftTop="9px"
              iconShiftRight="10px"
              id="patient_nom_lookup"
            >
              <MdOutlineCancel size="1.5rem" onClick={onResetLookup} />
            </InputIcon>
          </div>
        </div>
        <div className={styles.inputSpacer}>
          <label htmlFor="patient_ddn_lookup" className={styles.label}>
            DDN
          </label>
          <div>
            <InputIcon
              value={ddnLookup}
              onChange={setDdnLookup}
              tooltip="Effacer"
              showIcon={!!ddnLookup}
              iconTestId="patient_ddn_lookup_icon"
              isValid={isValidDDN}
              iconShiftTop="9px"
              iconShiftRight="10px"
            >
              <MdOutlineCancel size="1.5rem" onClick={onResetDdnLookup} />
            </InputIcon>
          </div>
        </div>
        {candidates && candidates.length > 0 && (
          <div className={styles.checkboxSpacer}>
            <input
              type="checkbox"
              id="multiselectcheckbox"
              name="multiselectcheckbox"
              checked={isMultiSelectionEnabled}
              onChange={() =>
                setIsMultiSelectionEnabled(!isMultiSelectionEnabled)
              }
            />
            <label htmlFor="multiselectcheckbox">
              Sélectionner plusieurs patients
            </label>
          </div>
        )}
        <div className="">
          <div className="">
            <div id="candidats_frame" className={styles.candidats_frame}>
              <PatientCandidatsList
                showCheckBoxes={isMultiSelectionEnabled}
                candidats={sortedCandidates}
                selected={selectedPatientsIds}
                onSelectPatient={selectPatientId}
                lookup={lookup}
                onToggleSelectedPatient={togglePatientId}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PatientLookup;
